import React, { useEffect, useState } from "react";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../components/SelectButton";
import download from "../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import editBond from "../../assets/editBond.png";
import delBond from "../../assets/deleteBond.png";
import moment from "moment";
import ReactTable from "../../components/ReactTable";
import eye from "../../assets/eye.png";
import CustomPagination from "../../components/CustomPagination";
import axios from "axios";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const ReportMain = () => {
  const navigate = useNavigate();
  const [reportDetails, setReportDetails] = useState([]);
  const [error, setError] = useState(null);

  const [selectNumber, setSelectedNumber] = useState("10");
  const [searchInput, setSearchInput] = useState("");
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem('reportPage');
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);

  const columnHelper = createColumnHelper();

  const optionsShow = ["All", "1", "2","5", "10", "20", "50"];

  const fetchBondDetails = async () => {
    const endpoint = `${base_url}/${api_type}/reports`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          page: page,
          search: searchInput,
          limit: selectNumber === "All" ? undefined : parseInt(selectNumber),
        },
      });
      console.log("response report", response);
      setReportDetails(response?.data?.data?.list);
      setPage(response?.data?.data?.currentPage);
      setTotal(response?.data?.data?.totalPages);
      setPazeSize(response?.data?.data?.totalRecords);
    } catch (err) {
      console.error("Failed to fetch reports:", err);
      setError(err.message);
    }
  };

  const deleteBondsId = async (id) => {
    const endpoint = `${base_url}/${api_type}/bonds/${id}`;

    try {
      const response = await axios.delete(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      // setReportDetails(response?.data?.data?.bonds);

      // setPage(response?.data?.data?.pagination?.currentPage);

      // setTotal(response?.data?.data?.totalPages);
      // setPazeSize(response?.data?.data?.totalRecords);
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchBondDetails();
  }, [page, searchInput, selectNumber]);

  // Add searchInput to useEffect dependencies and trigger fetch when empty
  useEffect(() => {
    if (searchInput === '') {
      fetchBondDetails();
    }
  }, [searchInput]);

  const handleSearchInput = (value) => {
    setSearchInput(value);
  };

  const handleSelectNumber = (value) => {
    setSelectedNumber(value);
    setPage(1);
    setPazeSize(value === "All" ? total : parseInt(value));
  };

  const handleSearch = () => {
    fetchBondDetails();
  };

  const columns = [
    columnHelper.accessor("name", {
      cell: (info) => info.renderValue(),
      header: () => <span>Investor Name</span>,
    }),

    columnHelper.accessor("uccCode", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className="flex ">
          <span>UCC Code</span>
        </div>
      ),
    }),

    // columnHelper.accessor("settlementPeriod", {
    //   cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
    //   header: () => (
    //     <div className="flex justify-center items-center ">
    //       <span>Settlement Preference</span>
    //     </div>
    //   ),
    // }),

    columnHelper.accessor("settlementPeriod", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className="flex ">
          <span>Statement Preference</span>
        </div>
      ),
    }),

    columnHelper.accessor("statementDate", {
      cell: (info) => {
        let createdAt = info?.getValue();
        // Check if the date value exists before formatting
        createdAt = createdAt ? moment(createdAt).format("DD-MM-YYYY") : "N/A";
        return createdAt;
      },
      header: () => <span>Statement Date</span>,
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        console.log("investorid", uniqueId);
        const NavigateScheme = (uniqueId) => {
          navigate("/report/edit", {
            state: {
              uniqueId: uniqueId,
            },
          });
        };
        const deleteBond = (id) => {
          deleteBondsId(id);
        };
        return (
          <div className="flex justify-start ">
            <img
              onClick={() => NavigateScheme(uniqueId)}
              src={eye}
              alt="Eye "
              className="cursor-pointer pr-8"
            />
            {/* <img
              onClick={() => deleteBond(uniqueId)}
              src={delBond}
              alt="Eye "
              className="cursor-pointer"
            /> */}
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];

  return (
    <>
      <div className="ml-4">
        <div className=" mt-[65px] mb-4 flex items-center justify-start">
          <button className="bg-[#035C98] text-white px-4 py-1 rounded-r-[10px] flex gap-2">
            <span>Investor</span>
          </button>
        </div>
        <div className="bg-white px-6 pb-6 pt-2 rounded-lg mb-4 overflow-auto">
          <h1 className="text-[#252C32] text-[24px] font-bold">
            Investor Report{" "}
          </h1>

          <div className="border-b border-1 border-gray-300 pb-1"></div>
          <div class="">
            <div class="flex flex-wrap items-center justify-between gap-x-2 py-4 gap-y-4">
              <div class="flex gap-0.5">
                <input
                  type="text"
                  placeholder="Search by Unique ID/name"
                  className="rounded-l-[10px] w-[217px]"
                  value={searchInput}
                  onChange={(e) => handleSearchInput(e?.target?.value)}
                />
                <button 
                  onClick={handleSearch}
                  className="bg-[#035C98] text-white font-bold py-2 px-4 rounded-r-[10px]"
                >
                  Search
                </button>
              </div>
            </div>
            <div className="flex items-center w-[154px] mt-4 gap-x-2">
              <p className="text-gray-500 text-sm font-bold">Show</p>
              <SelectButton
                options={optionsShow}
                selectedValue={selectNumber}
                onSelect={handleSelectNumber}
              />
              <p className="text-gray-500 text-sm font-bold">Entries</p>
            </div>
          </div>
        </div>

        <div className="w-full font-poppins">
          <ReactTable
            key={JSON?.stringify(reportDetails)}
            defaultData={reportDetails}
            columns={columns}
          />
        </div>

        {reportDetails?.length > 0 && (
          <div className="w-auto">
            <CustomPagination
              currentPage={page}
              setCurrentPage={setPage}
              totalItems={total}
              itemsPerPage={pageSize}
              maxPageNumbersToShow={5}
              storageKey="reportPage"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ReportMain;
